import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { far, fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback } from 'react';

/**
 * Per requirement GP-13, this provides a list of a reallocation's ratios
 */
export const ReallocRatioList = ({ calcObj }) => {

  const { navigateTo } = useNavState();

  const augRowsReq = useCallback((rowsReq) => {
    if (!calcObj) return;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('calcId', calcObj.id));
  }, [calcObj.id]);


  const augFieldDefs = useCallback((fieldToFieldDef) => {
    if (!calcObj) return;
    let columns;
    if (calcObj.type === 'REALLOC_SPLIT') {
      columns = ['ndc11', 'origWac', 'splitWac', 'reallocRatio' ];
    } else {
      columns = ['discPeriod', 'salePeriod', 'reallocDims', 'reallocKey', 'totalDisc', 'totalAmt', 'reallocRatio'];
    } 


    Object.keys(fieldToFieldDef).forEach(colName => {
      if (!columns.includes(colName)) {
        delete fieldToFieldDef[colName];
      } else {
        const index = columns.indexOf(colName);
        fieldToFieldDef[colName].precedence = (index + 1) * 100
      }
    });
  }, [calcObj.id]);

  //const getContextMenuItems = (params) => {
    //TODO: Add Trx Viewers with v6 ViewerPlugin
  //}

  const getContextMenuItems = (params) => {
    const data = params.node.data;

    let navState = {
          mode: Mode.DETAIL,
          entityId: data.id,
    }

    const contextMenuItems = [
          {
            name: 'Details',
            icon: fas.faInfoCircle,
            action: () => navigateTo('gp/calc-prod-res', navState)
          }
        ]

    const viewerReqParam = {
      code: 'REALLOC_TRX',
      data: data,
      calc: calcObj,
      ndcLevel: 'NDC11'
    }

    let trxsButton = {};
    if (calcObj.type === 'REALLOC_SPLIT') {
        trxsButton = {
        name: 'Original Transactions',
        icon: fas.faCalculator,
        subMenu: [
          {
            name: 'Direct Sale Transactions',
            icon: fas.faFileInvoice,
            action: () => navigateTo('gp/realloc-viewer', { viewerReqParam: {...viewerReqParam, trxSrcCode: 'DS', orig: true}, entity: 'REALLOC_RATIO' })
          },
          {
            name: 'Indirect Sale Transactions',
            icon: fas.faClipboard,
            action: () => navigateTo('gp/realloc-viewer', { viewerReqParam: {...viewerReqParam, trxSrcCode: 'IS', orig: true}, entity: 'REALLOC_RATIO' })
          },
          {
            name: 'Rebate Transactions',
            icon: far.faListUl,
            action: () => navigateTo('gp/realloc-viewer', { viewerReqParam: {...viewerReqParam, trxSrcCode: 'RB', orig: true}, entity: 'REALLOC_RATIO' })
          }
        ]
      }
    } else {
      trxsButton = {
        name: 'Original Transactions',
        icon: fas.faCalculator,
        action: () => navigateTo('gp/realloc-viewer', { viewerReqParam: {...viewerReqParam, trxSrcCode: 'RB', orig: true}, entity: 'REALLOC_RATIO' })
      }
    }

    contextMenuItems.push(trxsButton);

    let reallocTrxsButton = {};
    if (calcObj.type === 'REALLOC_SPLIT') {
      reallocTrxsButton = {
        name: 'Reallocated Transactions',
        icon: fas.faRotate,
        subMenu: [
          {
            name: 'Direct Sale Transactions',
            icon: fas.faFileInvoice,
            action: () => navigateTo('gp/realloc-viewer', { viewerReqParam: {...viewerReqParam, trxSrcCode: 'DS', orig: false}, entity: 'REALLOC_RATIO' })
          },
          {
            name: 'Indirect Sale Transactions',
            icon: fas.faClipboard,
            action: () => navigateTo('gp/realloc-viewer', { viewerReqParam: {...viewerReqParam, trxSrcCode: 'IS', orig: false}, entity: 'REALLOC_RATIO' })
          },
          {
            name: 'Rebate Transactions',
            icon: far.faListUl,
            action: () => navigateTo('gp/realloc-viewer', { viewerReqParam: {...viewerReqParam, trxSrcCode: 'RB', orig: false}, entity: 'REALLOC_RATIO' })
          }
        ]
      }
    } else {
      reallocTrxsButton = {
        name: 'Reallocated Transactions',
        icon: fas.faRotate,
        action: () => navigateTo('gp/realloc-viewer', { viewerReqParam: {...viewerReqParam, trxSrcCode: 'RB', orig: false}, entity: 'REALLOC_RATIO' })
      }
    }

    contextMenuItems.push(reallocTrxsButton);

    return contextMenuItems;
  }


  return (
    <EntityList
      entity="REALLOC_RATIO"
      augRowsReq={augRowsReq}
      augFieldDefs={augFieldDefs}
      gridOptions={{
        getContextMenuItems
      }}
    />
  )
}